<template>
    <form
        method="post"
        autocomplete="off"
        enctype="multipart/form-data"
        @submit.prevent="changeStore"
    >
        <div class="row pt-2">
            <div class="col-12">
                <div class="form-group">
                    <label class="form-control-label" for="name"
                        >Locations</label
                    >
                    <template v-for="loc in locations" :key="loc.id">
                        <div class="custom-control custom-radio pb-2">
                            <input
                                name="dealer"
                                class="custom-control-input"
                                :value="loc.id"
                                :id="'location-' + loc.id"
                                type="radio"
                                v-model="selectedStore"
                            />
                            <label
                                class="custom-control-label cursor-pointer"
                                :for="'location-' + loc.id"
                                >{{ loc.name }} - {{ loc.address }},
                                {{ loc.city }}, {{ loc.state }},
                                {{ loc.zip_code }}</label
                            >
                        </div>
                    </template>
                    <div class="custom-control custom-radio pb-2">
                        <input
                            name="dealer"
                            class="custom-control-input"
                            value="0"
                            id="location-all"
                            type="radio"
                            v-model="selectedStore"
                        />
                        <label
                            class="custom-control-label cursor-pointer"
                            for="location-all"
                            >ALL LOCATIONS</label
                        >
                    </div>
                </div>
            </div>
        </div>
        <button
            type="submit"
            class="mt-5 btn btn-outline-orange text-orange text-uppercase float-right"
        >
            SELECT
        </button>
    </form>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";

export default {
    props: [],
    emits: ["closeModal"],
    components: {},
    setup() {
        const store = useStore();

        let user = computed(function () {
            return store.state.user;
        });
        let currentLocation = computed(function () {
            return store.state.currentLocation;
        });
        let locations = computed(function () {
            return store.state.locations;
        });

        function setCurrentLocation(val) {
            store.commit("setCurrentLocation", val);
        }

        function updateRecords(loc, user) {
            store.dispatch("getAllOrders", { location_id: loc.id });
            store.dispatch("getAllPricelists", {
                pricelist_id: loc.pricelist_id,
            });
            store.dispatch("getAllCategories", {
                pricelist_id: loc.pricelist_id,
                location_arr: user.locations_arr,
            });
            store.dispatch("getAllInvoices", { location_id: loc.id });
            store.dispatch("getTotalOrders", { location_id: loc.id });
            store.dispatch("orderLinesReport", { location_id: loc.id });
            store.dispatch("getDealerPriceLists", { location_id: loc.id });
        }

        function getLocations(userId) {
            store.dispatch("getLocations", { user_id: userId });
        }

        onMounted(() => {});

        return {
            store,
            user,
            currentLocation,
            locations,
            setCurrentLocation,
            updateRecords,
            getLocations,
        };
    },
    data() {
        return {
            selectedStore: null,
        };
    },
    mounted() {
        this.selectedStore = this.currentLocation.id;
        this.getLocations(this.user.id);
    },
    methods: {
        changeStore() {
          let selectedLocation = null;

          if (this.selectedStore == 0) {
            selectedLocation = {
                id: this.selectedStore,
                pricelist_id: this.selectedStore,
                name: "ALL DEALERS",
                is_speq: false
            };

            this.setCurrentLocation(selectedLocation);
            this.updateRecords(selectedLocation, this.user);

          } else {
            selectedLocation = this.locations.filter(
                (x) => x.id == this.selectedStore
            )[0];

            this.setCurrentLocation(selectedLocation);
            this.updateRecords(selectedLocation, this.user);
          }

          // clear the orders when changing stores
          if (window.location.pathname.includes('/new-order')) {
            localStorage.setItem("orders", JSON.stringify([]));
            this.store.commit("setOrders", []);
            window.emitter.emit("refreshCreateOrderPage");
          }

          // Validate current path for is_speq
          if (this.$route.meta.is_speq && !selectedLocation?.is_speq || this.$route.name == 'unauthorized') {
            this.$router.push({ name: 'dashboard' });
          }

          this.$emit("closeModal");
        },
    },
};
</script>
